// extracted by mini-css-extract-plugin
export default {"symbol":"Symbol_symbol__Zr2Vc","symbol_disabled":"Symbol_symbol_disabled__7BHt2"};